import {AnalyticsParameterConfigGraphQL} from '../../../../graphql-fragments/insights/__generated/AnalyticsParameterConfigGraphQL';
import {CONFIG_TYPENAME_TO_PARAMETER_TYPE} from '../ParameterConstants';
import {ParameterType} from '../ParameterTypes';

export default function getParameterType(config: AnalyticsParameterConfigGraphQL): ParameterType {
  return CONFIG_TYPENAME_TO_PARAMETER_TYPE[config.__typename];
}
